export default __webpack_public_path__ + "static/media/Woman-of-swans.369719d5.jpg";